// rv-trust: loaded only where the section is used (sections/rv-trust.liquid)

// Pause the mobile marquee while it is being touched.
class RvTrustMarquee extends HTMLElement {
  connectedCallback() {
    const pause = () => this.setAttribute('data-paused', '');
    const resume = () => this.removeAttribute('data-paused');
    this.addEventListener('touchstart', pause, { passive: true });
    this.addEventListener('touchend', resume, { passive: true });
    this.addEventListener('touchcancel', resume, { passive: true });
  }
}

if (!customElements.get('rv-trust-marquee')) customElements.define('rv-trust-marquee', RvTrustMarquee);
